export const ACCEPT_REPAIR_ORDER = 'APPOINTMENT/GENERAL/ACCEPT_REPAIR_ORDER';
export const ACCEPT_REPAIR_ORDER_SUCCESS = 'APPOINTMENT/GENERAL/ACCEPT_REPAIR_ORDER_SUCCESS';
export const ACCEPT_REPAIR_ORDER_FAILURE = 'APPOINTMENT/GENERAL/ACCEPT_REPAIR_ORDER_FAILURE';

export const PAY_ONLINE_BILLING = 'APPOINTMENT/GENERAL/PAY_ONLINE_BILLING';
export const PAY_ONLINE_BILLING_SUCCESS = 'APPOINTMENT/GENERAL/PAY_ONLINE_BILLING_SUCCESS';
export const PAY_ONLINE_BILLING_FAILURE = 'APPOINTMENT/GENERAL/PAY_ONLINE_BILLING_FAILURE';

export const CONFIRM_DROPOFF = 'APPOINTMENT/KEY_DEPOSIT/CONFIRM_DROPOFF';
export const CONFIRM_DROPOFF_SUCCESS = 'APPOINTMENT/KEY_DEPOSIT/CONFIRM_DROPOFF_SUCCESS';
export const CONFIRM_DROPOFF_FAILURE = 'APPOINTMENT/KEY_DEPOSIT/CONFIRM_DROPOFF_FAILURE';

export const CONFIRM_PICK_UP = 'APPOINTMENT/KEY_RETRIEVE/CONFIRM_PICK_UP';
export const CONFIRM_PICK_UP_SUCCESS = 'APPOINTMENT/KEY_RETRIEVE/CONFIRM_PICK_UP_SUCCESS';
export const CONFIRM_PICK_UP_FAILURE = 'APPOINTMENT/KEY_RETRIEVE/CONFIRM_PICK_UP_FAILURE';

export const OPEN_DROPOFF_LOCKER = 'APPOINTMENT/KEY_DEPOSIT/OPEN_DROPOFF_LOCKER';
export const OPEN_DROPOFF_LOCKER_SUCCESS = 'APPOINTMENT/KEY_DEPOSIT/OPEN_DROPOFF_LOCKER_SUCCESS';
export const OPEN_DROPOFF_LOCKER_FAILURE = 'APPOINTMENT/KEY_DEPOSIT/OPEN_DROPOFF_LOCKER_FAILURE';

export const OPEN_PICK_UP_LOCKER = 'APPOINTMENT/KEY_RETRIEVE/OPEN_PICK_UP_LOCKER';
export const OPEN_PICK_UP_LOCKER_SUCCESS = 'APPOINTMENT/KEY_RETRIEVE/OPEN_PICK_UP_LOCKER_SUCCESS';
export const OPEN_PICK_UP_LOCKER_FAILURE = 'APPOINTMENT/KEY_RETRIEVE/OPEN_PICK_UP_LOCKER_FAILURE';

export const CONFIRM_CLIENT_DOCUMENTS = 'APPOINTMENT/GENERAL/CONFIRM_CLIENT_DOCUMENTS';
export const CONFIRM_CLIENT_DOCUMENTS_SUCCESS = 'APPOINTMENT/GENERAL/CONFIRM_CLIENT_DOCUMENTS_SUCCESS';
export const CONFIRM_CLIENT_DOCUMENTS_FAILURE = 'APPOINTMENT/GENERAL/CONFIRM_CLIENT_DOCUMENTS_FAILURE';

export const REPORT_ISSUES = 'APPOINTMENT/GENERAL/REPORT_ISSUES';
export const REPORT_ISSUES_SUCCESS = 'APPOINTMENT/GENERAL/REPORT_ISSUES_SUCCESS';
export const REPORT_ISSUES_FAILURE = 'APPOINTMENT/GENERAL/REPORT_ISSUES_FAILURE';

export const ACCEPT_RENTAL_DOCUMENTS = 'APPOINTMENT/GENERAL/ACCEPT_RENTAL_DOCUMENTS';
export const ACCEPT_RENTAL_DOCUMENTS_SUCCESS = 'APPOINTMENT/GENERAL/ACCEPT_RENTAL_DOCUMENTS_SUCCESS';
export const ACCEPT_RENTAL_DOCUMENTS_FAILURE = 'APPOINTMENT/GENERAL/ACCEPT_RENTAL_DOCUMENTS_FAILURE';
